import { AppleAuthUserPayload } from 'services/auth';

import { AppleResponseUserData } from './types';

export const composeAppleRedirectURI = (): string => {
    if (config.DEBUG && window.localStorage.getItem('apple')) {
        // for localhost can be paste https://edo-dev.vchasno.com.ua/auth-api/providers/apple - to check apple auth flow
        // it will not send the code to host and will not be able to get the token
        return window.localStorage.getItem('apple')!;
    }

    return `${window.location.origin}/auth-api/providers/apple`;
};

export const convertAppleResponseUserToPayload = (
    user: AppleResponseUserData,
): AppleAuthUserPayload => {
    return {
        email: user.email ?? '',
        name: user.name,
    };
};
